import { render, staticRenderFns } from "./Get-faqs.vue?vue&type=template&id=2ae23093&"
import script from "./Get-faqs.vue?vue&type=script&lang=js&"
export * from "./Get-faqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports